import Payment from 'payment';
import { CREDIT_CARD } from 'common/const';

const getCreditCard = (number) =>
  Object.values(CREDIT_CARD).find(
    ({ db }) => db.toLowerCase() === Payment.fns.cardType(number),
  ) ?? {};

export default getCreditCard;
